import NotificationsIcon from "@mui/icons-material/Notifications";
import Box from "@mui/material/Box";
import type { ColumnDef } from "@tanstack/react-table";

import type { DriverRow } from "@/types/driver";
import ColumnHeader from "../ui/ColumnHeader";
import type { ColumnFilterOptions } from ".";

/** Row-level feed notification indicator; shown in the leading driver-identifying column (name or promoted username). */
export function DriverFeedNotificationIcon({ feedPrefId }: { feedPrefId: string | null | undefined }) {
  return (
    <NotificationsIcon
      sx={{
        fontSize: "15px",
        flexShrink: 0,
        color: "#eab308",
        visibility: feedPrefId ? "visible" : "hidden",
      }}
    />
  );
}

function DriverNameCell({ driver, showNotificationBell }: { driver: DriverRow; showNotificationBell: boolean }) {
  return (
    <Box sx={{ display: "flex", width: "100%", alignItems: "center", gap: 1, minWidth: 0 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0, flex: 1, overflow: "hidden" }}>
        <Box sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{driver.name}</Box>
      </Box>
      {showNotificationBell ? <DriverFeedNotificationIcon feedPrefId={driver.feedPrefId} /> : null}
    </Box>
  );
}

export function driverNameColumn(
  options: ColumnFilterOptions,
  layout: { frozen: boolean; includeSort: boolean; includeNotificationBell: boolean } = {
    frozen: true,
    includeSort: true,
    includeNotificationBell: true,
  },
): ColumnDef<DriverRow> {
  return {
    accessorKey: "name",
    header: () => (
      <ColumnHeader title="Driver" extra={layout.includeSort ? options.getColumnExtra("driver") : undefined} />
    ),
    cell: ({ row }) => <DriverNameCell driver={row.original} showNotificationBell={layout.includeNotificationBell} />,
    meta: layout.frozen ? { frozen: true } : { flex: 1.5 },
    size: 215,
    minSize: 200,
    enableSorting: false,
    enableGlobalFilter: false,
    enableHiding: false,
  };
}
